import React, {useEffect, useState, useRef} from 'react'
// import {districts} from './Options'
import Select from 'react-select'
import Sidebar from '../Sidebar'
import Multiselect from 'multiselect-react-dropdown';
import {optionProductsByProducts} from '../Options';
// import env from 'react-dotenv'
export default function SowingForm() {
    //all the states
    const [seed_varieties, setSV] = useState()
    const [seed_name, setSN] = useState()
    const [district, setDistrict] = useState()
    const [district_id, setDistrictID] = useState()
    const [specification, setSpec] = useState()
    const [germination, setGerm] = useState()
    const [year, setYear] = useState()
    //get districts
    const [districts, setDistricts] = useState([])
    //for getting to the item quicker
    const [districts2, setDistricts2] = useState([])
    const [selectedOptions, setSelectedOptions] = useState('')
    const [selectedOptions2, setSelectedOptions2] = useState('')

    //options for the multi-district feature
    const [selectedOptions0, setSelectedOptions0] = useState([])
    const [options, setOptions] = useState([])

    //all the refs
    const snRef = useRef(null)
    const svRef = useRef(null)
    const dRef = useRef(null)
    const sRef = useRef(null)
    const gRef = useRef(null) 
    const yRef = useRef(null)

    const ferrit = async() =>{
      const token = sessionStorage.getItem('token')
      const response = await fetch(`${process.env.REACT_APP_API_URL}/getDistricts`,{
        headers: {
          'x-access-token': token
        }
      })
      const data = await response.json()
      setDistricts(data)
    }
    useEffect(()=>{
      ferrit()
    },[])
    useEffect(()=>{
      const crickets = districts
      const searchTerm = crickets.map((cricket)=>({
        value:String(cricket.district_id),
        label: cricket.district
      }))
      setDistricts2(searchTerm)
    },[districts])


    

    //seed_varieties handler
    const varietiesHandler = (e) =>{
        setSV(e.target.value)
    }

    useEffect(()=>{
       // console.log(seed_varieties)
    }, [seed_varieties])

    //seed_name handler
    const nameHandler = (e) =>{
        setSN(e.target.value)
    }

    //handler setting
    const yearHandler = (e) =>{
      const x = e.target.value
      setYear(x)
    }

    
    useEffect(()=>{
       // console.log(seed_name)
    }, [seed_name])

    const districtHandler = (item) => {
      const selectedName = item;
      const selectedOption = districts.find((district) => district.district_id === selectedName);
    
      if (selectedOption) {
       // console.log(selectedOption);
        setDistrict(selectedOption.district);
        setDistrictID(selectedOption.district_id);
      } else {
        // Handle the case when the selected district is not found
        console.error(`District '${selectedName}' not found.`);
        // You may want to clear or reset the selected district and ID here
      }
    };
  
  useEffect(()=>{
   // console.log(district)
   // console.log(district_id)
  }, [district, district_id])

  //if the dynamic dropdown
  const districtHandler2 =(e)=>{
    const selectedName = e.target.value;
    const selectedOption = districts.find(district => district.district === selectedName);
   // console.log(selectedOption)
    setDistrict(selectedName)
    setDistrictID(selectedOption.district_id)
  }

    useEffect(()=>{
       // console.log(district)
    }, [district])

    //specification handler
    const specHandler = (e) =>{
        setSpec(e.target.value)
    }

    useEffect(()=>{
       // console.log(specification)
    }, [specification])

    //Germination handler
    const germHandler = (e) =>{
        setGerm(e.target.value)
    }

    useEffect(()=>{
       // console.log(germination)
    }, [germination])

    //reset fields
    const reset=()=>{
        dRef.current.resetSelectedValues()
        snRef.current.value=''
        svRef.current.value=''
        // dRef.current.value=''
        sRef.current.value=''
        gRef.current.value=''
        yRef.current.value =''
        setSV(null)
        setSN(null)
        setSpec(null)
        setGerm(null)
        setDistrict(null)
        setDistrictID(null)
        setSelectedOptions(null)
        setSelectedOptions2(null)
        setYear(null)
        setYear(null)
    }

    useEffect(()=>{
     // console.log(year)
    },[year])

    const handleSubmit = async(e) =>{
        e.preventDefault()
        const sowing = {seed_varieties, seed_name, district, district_id, specification, germination, year}
       // console.log(sowing)
        const token = sessionStorage.getItem('token')
        const response = await fetch(`${process.env.REACT_APP_API_URL}/create-sowing`, {
            method:'POST',
            headers:{
                'Content-Type':'application/json',
                'x-access-token':token
            },
            body:JSON.stringify(sowing)
            }
        )
        // .then(console.log("Successfully submitted")).then(reset())
    }


    const handleSubmit2 = (e) => {
      e.preventDefault();

      const variables = [ seed_varieties, seed_name, selectedOptions, germination, specification, year];
      if (variables.every((variable) => typeof variable === 'undefined')) {
        return alert('No field should be empty');
      } 

      if (variables.some((variable) => typeof variable === 'undefined')) {
        return alert('No field should be empty 2')
      } 

  
     
        const prices = selectedOptions.map((option) => ({
          seed_varieties,
          seed_name,
          district_id: option.value,
          district: option.name,
          germination,
          specification,
          year
        }));

      const price = {
        seed_varieties,
        seed_name,
        district_id,
        district,
        germination,
        specification,
        year
       }

           // console.log(prices)

      const token = sessionStorage.getItem('token')
    
      fetch(`${process.env.REACT_APP_API_URL}/create-sowing2`, {
        
        method: 'POST',
        headers: {
          "Content-Type" : "application/json",
          "x-access-token":token
        },
        body: JSON.stringify(prices)
      }).then(() => {
        reset()
        // setDisplayAlert(true)
       // console.log("New price record(s) added");    
       
      }).catch((err) => {
       // console.log("Unable to add record" + err);
      });
    };


    const ferrit2 = async() =>{
        const response = await fetch(`${process.env.REACT_APP_API_URL}/getDistrictLookup`)
     // console.log("Got the data")
      const data0 = await response.json()
      const data = data0.map((item)=>{
        return{
          value: item.district_id,
          name: item.district
        }
      })
      //// console.log("ayo, data here", data)
      setOptions(data)
    }

    useEffect(()=>{
      ferrit2()
    },[])

    useEffect(()=>{
     // console.log("ayo options here", options)
    },[options])

    //dealing with multiple states
    const handleSelectStateOptions =  (selectedList)=>{
      setSelectedOptions(selectedList)
    }
    useEffect(()=>{
     // console.log("Hemlo", selectedOptions)
    },[selectedOptions])

  return (
<>

<div className="sidebar">
    <Sidebar/>
    </div>
    <div id='tabler'> 

    <h1>Sowing Form</h1>

      <form onSubmit={handleSubmit2} className='needs-validation'>

      {/* <div className="col-md-6">
                  <label htmlFor="inputGroupSelect07" className="form-label">Districts</label>
                  <Select ref={dRef} options={districts2}  value={selectedOptions}  placeholder="station"  onChange={(stat)=>{
                   // console.log("This is the value", stat)
                    const {value, label} = {...stat}
                   // console.log(value, label)
                    setSelectedOptions(stat)
                    districtHandler(value)
                  }} isSearchable noOptionsMessage={()=> "Not found"}/>
              </div> */}


              <div className="col-md-6">
    <label for="formGroupExampleInput2" class="form-label">District</label>
            <Multiselect 
              options={options}
              displayValue='name' 
              selectedValues={selectedOptions}
              onSelect={handleSelectStateOptions}
              onRemove={(selectedList) => {
                setSelectedOptions(selectedList);
            }}
              closeOnSelect={false}
              avoidHighlightFirstOption
              ref={dRef}
            />
    </div>
              <label htmlFor="num-value" className="form-label">Year</label>
      <div class="input-group mb-3">
      <select className="form-select" ref={yRef}  id="num-value" onChange={yearHandler} required aria-label="Select example">
                    <option value="">Select year</option>
                          <option value="2025-26">2025-26</option>
                          <option value="2024-25">2024-25</option>
                          <option value="2023-24">2023-24</option>
                          <option value="2022-23">2022-23</option>
                          <option value="2021-22">2021-22</option>
                          <option value="2020-21">2020-21</option>
                          <option value="2019-20">2019-20</option>
                          <option value="2018-19">2018-19</option>
                          <option value="2017-18">2017-18</option>
                          <option value="2016-17">2016-17</option>
                          <option value="2015-16">2015-16</option>
                          <option value="2014-15">2014-15</option>
                          <option value="2013-14">2013-14</option>
                          <option value="2012-13">2012-13</option>
                          <option value="2011-12">2011-12</option>
                          <option value="2010-11">2010-11</option>
                    </select>       
                    </div>
    
      <label htmlFor="num-value" className="form-label">Seed Varieties</label>
      <div class="input-group mb-3">
        <input type="text" class="form-control" ref={svRef} onChange={varietiesHandler} id='num-value' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" required/>
       </div>

       <label htmlFor="num-value" className="form-label">Seed Names</label>
      <div class="input-group mb-3">
        <input type="text" class="form-control" ref={snRef} onChange={nameHandler} id='num-value' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" required/>
       </div>

       <div class="mb-3">
  <label for="exampleFormControlTextarea1" class="form-label">Specification</label>
  <textarea class="form-control" value={specification} ref={sRef} onChange={specHandler} maxLength={160}  id="exampleFormControlTextarea1" rows="3" required></textarea>
</div>
<p style={{color:"grey"}}>160 characters</p>



       <label htmlFor="num-value" className="form-label">Germination</label>
      <div class="input-group mb-3">
        {/* <input type="text" class="form-control" value={form.crop_condition} ref={cRef} onChange={cropConditionHandler} id='num-value' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" required/> */}
       <select className="form-select" ref={gRef} onChange={germHandler} id='num-value' required> 
       <option>Select...</option>
    <option>Poor</option>
    <option>Fair</option>
    <option>Good</option>
    <option>Excellent</option>
  </select>
       </div>

       <button type="submit"  className="btn submit-btn">Submit</button>
      </form>
    </div>
</>
  )
}
